import { FileText } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Avatar } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { printBordro } from '../../lib/bordroActions'
import type { BordroSatir } from '../../types'
import { SectionCard } from '../SectionCard'
import { BordroSummaryBody } from './BordroSummaryBody'

export function BordroSummary({ row, donem }: { row: BordroSatir | null; donem: string }) {
  const { t } = useTranslation()

  return (
    <SectionCard title={t('hr.personel.bordro.ozet')}>
      {row ? (
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <Avatar name={row.ad} className="size-9 sm:size-11" />
            <div className="min-w-0">
              <div className="font-semibold">{row.ad}</div>
              <div className="text-xs text-muted-foreground">
                {row.unvan} · {row.departman}
              </div>
              <div className="text-xs text-muted-foreground">
                {t('hr.personel.fields.sicil')}: {row.sicil}
              </div>
            </div>
          </div>
          <BordroSummaryBody row={row} />
          <Button variant="outline" className="w-full" onClick={() => void printBordro(row, donem)}>
            <FileText />
            {t('hr.personel.bordro.pdf')}
          </Button>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">{t('hr.personel.bordro.sec')}</p>
      )}
    </SectionCard>
  )
}
